import React from 'react';
import Add from './AddStencil';

const Edit = ({ originalNSD, currentUser, data, inspectionDetail, inspectionId, handleClick, debouncedValue, isFetching, setLoading, setLoadingValue, retreadNSD }) => {
  return <Add key={data.stencilNo} originalNSD={originalNSD}
    retreadNSD={retreadNSD}
    currentUser={currentUser} data={data} inspectionDetail={inspectionDetail} inspectionId={inspectionId} handleClick={handleClick} debouncedValue={debouncedValue}
    isFetching={isFetching} setLoadingValue={setLoadingValue}
  />;
};

export default Edit;
